/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SubmitPalAuthSubmissionRequest
 */
export interface SubmitPalAuthSubmissionRequest {
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof SubmitPalAuthSubmissionRequest
     */
    submission_form_data?: { [key: string]: any; };
    /**
     * 
     * @type {boolean}
     * @memberof SubmitPalAuthSubmissionRequest
     */
    upload_to_platform?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SubmitPalAuthSubmissionRequest
     */
    include_lead_summary_report?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SubmitPalAuthSubmissionRequest
     */
    comment?: string;
    /**
     * Required when submission_mode is efax.
     * @type {string}
     * @memberof SubmitPalAuthSubmissionRequest
     */
    destination_fax_number?: string;
    /**
     * Override the submission mode at submit time. 'hospital_initiated' prepares a hospital-managed submission. 'efax' sends the generated package through Documo and stores the Documo message id on the PAL submission.
     * @type {string}
     * @memberof SubmitPalAuthSubmissionRequest
     */
    submission_mode?: SubmitPalAuthSubmissionRequestSubmissionModeEnum;
}


/**
 * @export
 */
export const SubmitPalAuthSubmissionRequestSubmissionModeEnum = {
    HospitalInitiated: 'hospital_initiated',
    Efax: 'efax'
} as const;
export type SubmitPalAuthSubmissionRequestSubmissionModeEnum = typeof SubmitPalAuthSubmissionRequestSubmissionModeEnum[keyof typeof SubmitPalAuthSubmissionRequestSubmissionModeEnum];


/**
 * Check if a given object implements the SubmitPalAuthSubmissionRequest interface.
 */
export function instanceOfSubmitPalAuthSubmissionRequest(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function SubmitPalAuthSubmissionRequestFromJSON(json: any): SubmitPalAuthSubmissionRequest {
    return SubmitPalAuthSubmissionRequestFromJSONTyped(json, false);
}

export function SubmitPalAuthSubmissionRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SubmitPalAuthSubmissionRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'submission_form_data': !exists(json, 'submission_form_data') ? undefined : json['submission_form_data'],
        'upload_to_platform': !exists(json, 'upload_to_platform') ? undefined : json['upload_to_platform'],
        'include_lead_summary_report': !exists(json, 'include_lead_summary_report') ? undefined : json['include_lead_summary_report'],
        'comment': !exists(json, 'comment') ? undefined : json['comment'],
        'destination_fax_number': !exists(json, 'destination_fax_number') ? undefined : json['destination_fax_number'],
        'submission_mode': !exists(json, 'submission_mode') ? undefined : json['submission_mode'],
    };
}

export function SubmitPalAuthSubmissionRequestToJSON(value?: SubmitPalAuthSubmissionRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'submission_form_data': value.submission_form_data,
        'upload_to_platform': value.upload_to_platform,
        'include_lead_summary_report': value.include_lead_summary_report,
        'comment': value.comment,
        'destination_fax_number': value.destination_fax_number,
        'submission_mode': value.submission_mode,
    };
}

